import { createSvgIcon } from "@mui/material/utils";

export const ComparisonIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.84211 5.44H8V4H4.84211C3.82442 4 3 4.75187 3 5.68V14.32C3 15.2481 3.82442 16 4.84211 16H8V14.56H4.84211C4.69716 14.56 4.57895 14.4522 4.57895 14.32V5.68C4.57895 5.54781 4.69716 5.44 4.84211 5.44Z"
      fill="currentColor"
    />
    <path
      d="M11.4 2H10V18H11.4V16.0606H15.3667C16.269 16.0606 17 15.3011 17 14.3636V5.63636C17 5.18655 16.8277 4.75474 16.5215 4.43656C16.2152 4.11838 15.7996 3.93939 15.3667 3.93939H11.4V2ZM15.3667 5.39394C15.4286 5.39394 15.4879 5.41951 15.5316 5.46496C15.5754 5.51042 15.6 5.57197 15.6 5.63636V14.3636C15.6 14.428 15.5754 14.4896 15.5316 14.535C15.4879 14.5805 15.4286 14.6061 15.3667 14.6061H11.4V5.39394H15.3667Z"
      fill="currentColor"
    />
  </svg>,
  "ComparisonIcon"
);
